import { httpCreate } from './http';

const http = httpCreate('/srv/rainActivity/');

export const rainActivity = {
	saveRainActivity(activityId, body, params) {
		return http.post(`${activityId}`, body, { params });
	},
	getRainActivity(id) {
		return http.get(`${id}`);
	},
	putRainActivity(id, body) {
		return http.put(`${id}`, body);
	},
	prizeList(activityId, params) {
		return http.get(`list/${activityId}`, { params: params });
	},
	opeStatus(id) {
		return http.post(`${id}/open`);
	},
	deleteActivity(id) {
		return http.delete(`${id}`);
	},
	saveGuessActivity(activityId, body, params) {
		return http.post(`guess/${activityId}`, body, { params });
	},
	putGuessActivity(id, body) {
		return http.put(`guess/${id}`, body);
	},
	createRotary(activityId, body) {
		return http.post(`turntable/${activityId}?smsCode=${body.smsCode ? body.smsCode : ''}`, body);
	},
	editorRotary(id, body) {
		return http.put(`turntable/${id}?smsCode=${body.smsCode ? body.smsCode : ''}`, body);
	},
	closureRotary(id) {
		return http.post(`turntable/end/${id}`);
	},
};
